import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EmployeeService from "services/employee/EmployeeService";
import Utils from "utils";

export const SearchKhamChuyenGiaApi = createAsyncThunk(
  "KhamChuyenGia/SearchKhamChuyenGiaApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.searchKhamChuyenGia(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetKhamChuyenGiaByIdApi = createAsyncThunk(
  "KhamChuyenGia/GetKhamChuyenGiaByIdApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getKhamChuyenGiaById(id);
      response.data.startDate = Utils.convertMomentToDate(
        response.data.startDate,
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetKhamChuyenGiaCalendarApi = createAsyncThunk(
  "KhamChuyenGia/GetKhamChuyenGiaCalendarApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getKhamChuyenGiaCalendar(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertKhamChuyenGiaApi = createAsyncThunk(
  "KhamChuyenGia/UpSertKhamChuyenGiaApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await EmployeeService.upSertKhamChuyenGia(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchKhamChuyenGiaChiTietApi = createAsyncThunk(
  "KhamChuyenGia/SearchKhamChuyenGiaChiTietApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.searchKhamChuyenGiaChiTiet(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertKhamChuyenGiaChiTietApi = createAsyncThunk(
  "KhamChuyenGia/UpSertKhamChuyenGiaChiTietApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response =
        await EmployeeService.upSertKhamChuyenGiaChiTiet(payload);
      if (onSuccess) onSuccess(response.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetDanhMucKhamChuyenGiaApi = createAsyncThunk(
  "KhamChuyenGia/GetDanhMucKhamChuyenGiaApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getDanhMucKhamChuyenGia(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const SearchPhieuXacNhanKhamChuyenGiaApi = createAsyncThunk(
  "KhamChuyenGia/SearchPhieuXacNhanKhamChuyenGiaApi",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await EmployeeService.searchPhieuXacNhanKhamChuyenGia(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const GetPhieuXacNhanKhamChuyenGiaByIdApi = createAsyncThunk(
  "KhamChuyenGia/GetPhieuXacNhanKhamChuyenGiaByIdApi",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response =
        await EmployeeService.getPhieuXacNhanKhamChuyenGiaById(id);
      response.data.ngayKham = Utils.convertMomentToDate(
        response.data.ngayKham,
      );
      dispatch(
        SearchKhamChuyenGiaChiTietApi({
          khamChuyenGiaId: response.data.khamChuyenGiaId,
          branchId: response.data.branchId,
        }),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const UpSertPhieuXacNhanKhamChuyenGiaApi = createAsyncThunk(
  "KhamChuyenGia/UpSertPhieuXacNhanKhamChuyenGiaApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response =
        await EmployeeService.upSertPhieuXacNhanKhamChuyenGia(payload);
      if (onSuccess) onSuccess(response.data.data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  list: [],
  dmList: [],
  detail: {},
  detailList: [],
  phieuXacNhanList: [],
};

const khamChuyenGiaSlice = createSlice({
  name: "khamChuyenGia",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SearchKhamChuyenGiaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(SearchKhamChuyenGiaApi.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    });
    builder.addCase(SearchKhamChuyenGiaApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(GetKhamChuyenGiaByIdApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetKhamChuyenGiaByIdApi.fulfilled, (state, action) => {
      state.loading = false;
      state.detail = action.payload;
    });
    builder.addCase(GetDanhMucKhamChuyenGiaApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(GetDanhMucKhamChuyenGiaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetDanhMucKhamChuyenGiaApi.fulfilled, (state, action) => {
      state.loading = false;
      state.dmList = action.payload;
    });
    builder.addCase(GetKhamChuyenGiaByIdApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(UpSertKhamChuyenGiaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UpSertKhamChuyenGiaApi.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(UpSertKhamChuyenGiaApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(SearchKhamChuyenGiaChiTietApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      SearchKhamChuyenGiaChiTietApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.detailList = action.payload;
      },
    );
    builder.addCase(SearchKhamChuyenGiaChiTietApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(UpSertKhamChuyenGiaChiTietApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      UpSertKhamChuyenGiaChiTietApi.fulfilled,
      (state, action) => {
        state.loading = false;
      },
    );
    builder.addCase(UpSertKhamChuyenGiaChiTietApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(SearchPhieuXacNhanKhamChuyenGiaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      SearchPhieuXacNhanKhamChuyenGiaApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.phieuXacNhanList = action.payload;
      },
    );
    builder.addCase(SearchPhieuXacNhanKhamChuyenGiaApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(GetPhieuXacNhanKhamChuyenGiaByIdApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      GetPhieuXacNhanKhamChuyenGiaByIdApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.detail = action.payload;
      },
    );
    builder.addCase(GetPhieuXacNhanKhamChuyenGiaByIdApi.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(UpSertPhieuXacNhanKhamChuyenGiaApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      UpSertPhieuXacNhanKhamChuyenGiaApi.fulfilled,
      (state, action) => {
        state.loading = false;
      },
    );
    builder.addCase(UpSertPhieuXacNhanKhamChuyenGiaApi.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(GetKhamChuyenGiaCalendarApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetKhamChuyenGiaCalendarApi.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(GetKhamChuyenGiaCalendarApi.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default khamChuyenGiaSlice.reducer;
